var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandYoutube = function SvgBrandYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand-youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M24.26 8.095s-.233-1.654-.955-2.38c-.914-.957-1.936-.962-2.405-1.018-3.356-.244-8.395-.244-8.395-.244h-.01s-5.039 0-8.395.244c-.469.056-1.49.06-2.405 1.017-.722.727-.951 2.381-.951 2.381S.5 10.041.5 11.981V13.8c0 1.94.24 3.886.24 3.886s.233 1.655.95 2.381c.915.956 2.115.924 2.65 1.027 1.92.183 8.16.239 8.16.239s5.044-.01 8.4-.249c.469-.056 1.49-.06 2.405-1.017.722-.726.956-2.381.956-2.381s.239-1.94.239-3.886v-1.819c0-1.94-.24-3.886-.24-3.886m-14.24 7.913V9.263l6.483 3.384z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "brand-youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.898h24v24H.5z"
  })))));
};
export default SvgBrandYoutube;